<template>
  <v-menu v-model="showMenu" bottom left transition="slide-y-transition" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn x-small>
        <v-icon small v-on="on">mdi-cog</v-icon>
      </v-btn>
    </template>
    <template>
      <div class="border-wrap">
        <v-list dense>
          <!--
            Commentd.by.KWShin.2024.03.11.
            chartFields는 mixins된 모듈 motletable.js에 computed로 선언되어 있으며,
            이 컴포넌트를 사용하는 모틀릿의 부모가 모틀릿에게 전달한 motletOptions 내의
            monitor.monitorCode 값을 가지고 chart.js 모듈에 선언된 각 차트의 fields 값을 읽어온 것이다.
          -->
          <v-list-group v-if="chartFields.length > 1" no-action :style="{ width: '230px' }">
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.chart.item') }}</v-list-item-title>
            </template>
            <v-list-item :style="{ padding: '0px 16px' }">
              <v-radio-group v-model="selectedChartField" hide-details dense column>
                <v-radio v-for="(field, index) in chartFields" :key="index" :label="field.text" :value="field.code"></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list-group>
          <!-- BEGIN::Modified.by.KWShin.2022.07.13.
              '표시범위'를 수집주기(cycle)를 이용해서 보여주고 있는데,
              수집주기는 표시범위와 연관성이 없다. 이건 잘못된 것이다. 일단 '표시범위' 기능은 사용하지 않는다.
          -->
          <!--v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.duration') }}</v-list-item-title>
            </template>
            <v-list-item>
              <v-radio-group v-model="selectedCycle" hide-details dense column>
                <v-radio v-for="(cycle, index) in cycles" :key="index" :label="cycle.text" :value="cycle.value"></v-radio>
              </v-radio-group>
            </v-list-item>
          </!v-list-group-->
          <!-- FINISH::Modified.by.KWShin.2022.07.13. -->
          <!-- BEGIN::Added.by.SHJ.2026.04.13. -->
          <!-- Memory Type 선택 -->
          <v-divider v-if="memoryTypeOptions.use" class="mt-2 mb-2"></v-divider>
          <v-list-group v-if="memoryTypeOptions.use" no-action :style="{ width: '230px' }">
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.memoryType') }}</v-list-item-title>
            </template>
            <v-list-item :style="{ padding: '0px 16px' }">
              <v-radio-group v-model="selectedMemoryType" hide-details dense column>
                <v-radio v-for="(type, index) in memoryTypeOptions.types" :key="index" :label="type.text" :value="type.code"></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list-group>
          <!-- FINISH::Added.by.SHJ.2026.04.13. -->
          <!-- BEGIN::Added.by.SHJ.2026.04.22. -->
          <!-- Buffer Type 선택 -->
          <v-divider v-if="bufferTypeOptions.use" class="mt-2 mb-2"></v-divider>
          <v-list-group v-if="bufferTypeOptions.use" no-action :style="{ width: '230px' }">
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.bufferType') }}</v-list-item-title>
            </template>
            <v-list-item :style="{ padding: '0px 16px' }">
              <div :style="{ maxHeight: '260px', overflowY: 'auto', width: '100%' }">
                <v-radio-group v-model="selectedBufferType" hide-details dense column>
                  <v-radio v-for="(type, index) in bufferTypeOptions.types" :key="index" :label="type.text" :value="type.code"></v-radio>
                </v-radio-group>
              </div>
            </v-list-item>
          </v-list-group>
          <!-- FINISH::Added.by.SHJ.2026.04.22. -->
          <!-- BEGIN::Added.by.SHJ.2026.04.28. -->
          <!-- File System Type 선택 -->
          <v-divider v-if="fsysTypeOptions.use" class="mt-2 mb-2"></v-divider>
          <v-list-group v-if="fsysTypeOptions.use" no-action :style="{ width: '230px' }">
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.fsysType') }}</v-list-item-title>
            </template>
            <v-list-item :style="{ padding: '0px 16px' }">
              <div :style="{ maxHeight: '260px', overflowY: 'auto', width: '100%' }">
                <v-radio-group v-model="selectedFsysType" hide-details dense column>
                  <v-radio v-for="(type, index) in fsysTypeOptions.types" :key="index" :label="type.text" :value="type.code"></v-radio>
                </v-radio-group>
              </div>
            </v-list-item>
          </v-list-group>
          <!-- FINISH::Added.by.SHJ.2026.04.28. -->
          <!-- BEGIN::Added.by.SHJ.2026.04.13. -->
          <!-- Chart Type 선택 (Bar / Line) -->
          <v-divider v-if="chartTypeOptions.use" class="mt-2 mb-2"></v-divider>
          <v-list-group v-if="chartTypeOptions.use" no-action :style="{ width: '230px' }">
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.settings.chartType') }}</v-list-item-title>
            </template>
            <v-list-item :style="{ padding: '0px 16px' }">
              <v-radio-group v-model="selectedChartType" hide-details dense column>
                <v-radio label="Bar Chart" value="bar"></v-radio>
                <v-radio label="Line Chart" value="line" :disabled="lineChartDisabled"></v-radio>
              </v-radio-group>
            </v-list-item>
          </v-list-group>
          <!-- FINISH::Added.by.SHJ.2026.04.13. -->
          <!-- BEGIN::Added.by.KWShin.2024.03.05. -->
          <v-divider v-if="xAxisPointsOptions.use && xAxisPointsOptions.divider" class="mt-2 mb-2"></v-divider>
          <v-list-group v-if="xAxisPointsOptions.use" :style="{ width: '230px' }" no-action eager id="gear-menu-text-field">
            <template v-slot:activator>
              <v-list-item-title>{{ $t('motlet.set.xaxis.points') }}</v-list-item-title>
            </template>
            <v-text-field dense solo hide-details readonly :style="{ width: '220px', margin: '6px 0px 0px 0px' }" :value="xAxisPointsData.selected | comma">
              <template #prepend>
                <v-tooltip content-class="tooltip" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn id="minus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onXAxisMinus()">
                      <v-icon>mdi-minus-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('common.minus.10') }}</span>
                </v-tooltip>
              </template>
              <template #append-outer>
                <v-tooltip content-class="tooltip" top>
                  <template v-slot:activator="{ on, attrs }">
                    <div style="width: 120px">
                      <v-btn id="plus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onXAxisPlus()">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                      <span class="ml-2">({{ xAxisPointsData.timeText }})</span>
                    </div>
                  </template>
                  <span>{{ $t('common.plus.10') }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-list-group>
          <!-- FINISH::Added.by.KWShin.2024.03.05. -->
        </v-list>
      </div>
    </template>
  </v-menu>
</template>

<script>
// BEGIN::Added.by.KWShih.2024.03.05.
import { mapState } from 'vuex';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';
import { s2Hms } from '@/utils/formatter.js';
// FINISH::Added.by.KWShih.2024.03.05.
import motletable from '@/mixins/motletable';
// BEGIN::Added.by.KWShih.2024.03.11.
import chart from '@/components/motlet/settings/chart';
// FINISH::Added.by.KWShih.2024.03.11.

export default {
  mixins: [motletable],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // BEGIN::Added.by.KWShih.2024.03.05.
      showMenu: false,
      xAxisPointsData: {
        selected: 0,
        previous: 0,
        timeText: '',
      },
      // FINISH::Added.by.KWShih.2024.03.05.
      // BEGIN::Added.by.KWShin.2024.03.11.
      chartFieldData: {
        selected: '',
        previous: '',
      },
      // FINISH::Added.by.KWShin.2024.03.11.
      // BEGIN::Added.by.SHJ.2026.04.13.
      memoryTypeData: {
        selected: 'ALL',
        previous: 'ALL',
      },
      chartTypeData: {
        selected: 'bar',
        previous: 'bar',
      },
      // FINISH::Added.by.SHJ.2026.04.13.
      // BEGIN::Added.by.SHJ.2026.04.22.
      bufferTypeData: {
        selected: 'ALL',
        previous: 'ALL',
      },
      // FINISH::Added.by.SHJ.2026.04.22.
      // BEGIN::Added.by.SHJ.2026.04.28.
      fsysTypeData: {
        selected: 'ALL',
        previous: 'ALL',
      },
      // FINISH::Added.by.SHJ.2026.04.28.
    };
  },
  computed: {
    selectedChartField: {
      /**
       * Commented.by.KWShin.2024.03.11.
       * chartField는 motletable.js 모듈에 computed로 선언되어 있으며,
       * store의 /common.motlet[this.motletId].settings.chart.field 값이다.
       */
      get() {
        return this.chartField.code;
      },
      /**
       * Commented.by.KWShin.2024.03.11.
       * 화면의 radio-box에서 필드가 선택되면
       * motletable.js 모듈에 정의된 setChartField()를 호출하여 store에 선택된 필드값을 저장한다.
       */
      set(code) {
        this.setChartField(code);
        // BEGIN::Added.by.KWShin.2024.03.11.
        this.chartFieldData.selected = code;
        // FINISH::Added.by.KWShin.2024.03.11.
      },
    },
    // BEGIN::Removed.by.KWShin.2024.09.09.
    // selectedCycle: {
    //   get() {
    //     return this.monitor.cycle;
    //   },
    //   set(cycle) {
    //     this.setCycle(cycle);
    //   },
    // },
    // FINISH::Removed.by.KWShin.2024.09.09.
    // BEGIN::Added.by.KWShin.2024.03.06.
    ...mapState('common/user', ['username']),
    xAxisPointsOptions() {
      return this.motletState.xAxisPoints ? this.motletState.xAxisPoints : { use: false };
    },
    // FINISH::Added.by.KWShin.2024.03.06.
    // BEGIN::Added.by.SHJ.2026.04.13.
    memoryTypeOptions() {
      return this.motletState.memoryType ? this.motletState.memoryType : { use: false };
    },
    chartTypeOptions() {
      return this.motletState.chartType ? this.motletState.chartType : { use: false };
    },
    selectedMemoryType: {
      get() {
        return this.memoryTypeData.selected;
      },
      set(value) {
        this.memoryTypeData.selected = value;
        // ALL 선택 시 chart type을 bar로 강제
        if (value === 'ALL' && this.chartTypeData.selected === 'line') {
          this.chartTypeData.selected = 'bar';
        }
      },
    },
    selectedChartType: {
      get() {
        return this.chartTypeData.selected;
      },
      set(value) {
        this.chartTypeData.selected = value;
      },
    },
    // FINISH::Added.by.SHJ.2026.04.13.
    // BEGIN::Added.by.SHJ.2026.04.22.
    bufferTypeOptions() {
      return this.motletState.bufferType ? this.motletState.bufferType : { use: false };
    },
    selectedBufferType: {
      get() {
        return this.bufferTypeData.selected;
      },
      set(value) {
        this.bufferTypeData.selected = value;
        // ALL 선택 시 chart type을 bar로 강제
        if (value === 'ALL' && this.chartTypeData.selected === 'line') {
          this.chartTypeData.selected = 'bar';
        }
      },
    },
    // Line Chart 비활성화 조건: 실제 use=true인 type 옵션의 선택값이 'ALL'일 때만
    lineChartDisabled() {
      if (this.memoryTypeOptions.use && this.selectedMemoryType === 'ALL') return true;
      if (this.bufferTypeOptions.use && this.selectedBufferType === 'ALL') return true;
      // BEGIN::Added.by.SHJ.2026.04.28.
      if (this.fsysTypeOptions.use && this.selectedFsysType === 'ALL') return true;
      // FINISH::Added.by.SHJ.2026.04.28.
      return false;
    },
    // FINISH::Added.by.SHJ.2026.04.22.
    // BEGIN::Added.by.SHJ.2026.04.28.
    // memoryType/bufferType와 달리 fsysType.types는 차트가 bar 데이터에서 동적으로 채움.
    // motletState(store)는 register 시점 스냅샷이라 갱신 안됨 → this.options(props)로 직접 읽어야 reactive.
    fsysTypeOptions() {
      return this.options.fsysType ? this.options.fsysType : { use: false };
    },
    selectedFsysType: {
      get() {
        return this.fsysTypeData.selected;
      },
      set(value) {
        this.fsysTypeData.selected = value;
        if (value === 'ALL' && this.chartTypeData.selected === 'line') {
          this.chartTypeData.selected = 'bar';
        }
      },
    },
    // FINISH::Added.by.SHJ.2026.04.28.
  },
  watch: {
    // BEGIN::Added.by.KWShin.2024.03.06.
    showMenu(value) {
      if (value) {
        /*
         * 보여지는 싯점에 이 컴포넌트에서 조작할 데이터를 초기화 한다.
         */
        if (this.chartFields.length > 0) {
          this.chartFieldData.selected = this.chartField?.code ? this.chartField.code : chart[this.motletId].fields[0].code;
          this.chartFieldData.previous = this.chartFieldData.selected;
        }
        // BEGIN::Added.by.SHJ.2026.04.13.
        if (this.memoryTypeOptions.use) {
          this.memoryTypeData.selected = this.options.memoryType?.selected || 'ALL';
          this.memoryTypeData.previous = this.memoryTypeData.selected;
        }
        if (this.chartTypeOptions.use) {
          this.chartTypeData.selected = this.options.chartType?.selected || 'bar';
          this.chartTypeData.previous = this.chartTypeData.selected;
        }
        // FINISH::Added.by.SHJ.2026.04.13.
        // BEGIN::Added.by.SHJ.2026.04.22.
        if (this.bufferTypeOptions.use) {
          this.bufferTypeData.selected = this.options.bufferType?.selected || 'ALL';
          this.bufferTypeData.previous = this.bufferTypeData.selected;
        }
        // FINISH::Added.by.SHJ.2026.04.22.
        // BEGIN::Added.by.SHJ.2026.04.28.
        if (this.fsysTypeOptions.use) {
          this.fsysTypeData.selected = this.options.fsysType?.selected || 'ALL';
          this.fsysTypeData.previous = this.fsysTypeData.selected;
        }
        // FINISH::Added.by.SHJ.2026.04.28.
        if (this.xAxisPointsOptions.use) {
          this.xAxisPointsData.selected = this.xAxisPoints ? this.xAxisPoints : 60;
          this.xAxisPointsData.previous = this.xAxisPointsData.selected;
          // BEGIN:: Modified.by.KWShin.2024.09.23.
          // monitorCode 'C_ABAP_DB_THROUGHPUT', 'C_ABAP_DB_RESP_TIME'의 모데이터의 수집주기(code:A_ABAP_SSR)는
          // 30,000(30초)인데, 30초의 데이터를 10개로 나누어서 보여주므로 여기서 수집주기를 3초로 교정하여 준다.
          // this.xAxisPointsData.timeText = s2Hms(this.xAxisPointsData.selected * (this.monitor.cycle / 1000));
          // ------------------------------------------------------------------
          let cycle = this.monitor.cycle;
          // if (this.monitor.monitorCode == 'C_ABAP_DB_THROUGHPUT' || this.monitor.monitorCode == 'C_ABAP_DB_RESP_TIME') cycle = 3000;
          this.xAxisPointsData.timeText = s2Hms(this.xAxisPointsData.selected * (cycle / 1000));
          // FINISH:: Modified.by.KWShin.2024.09.23.
        }
      } else {
        /*
         * 감춰지는 싯점에 이 컴포넌트에서 조작한 데이터를 Vuex store에 반영하고,
         * api를 이용하여 서버 DB에도 반영하고,
         * 메인 컴포넌트가 변경된 조건에 따라 데이터를 다시 읽어 올수 있도록 bus에 이벤트를 보낸다.
         */
        if (this.chartFields.length > 1) {
          if (this.chartFieldData.selected !== this.chartFieldData.previous) {
            // 화면에서 선택된 필드 항목은 바로 store에 반영되므로 그냥 DB에만 저장한다.
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/chartField`,
                motletProperties: this.chartField.code,
              })
              .then(() => {
                bus.$emit(`update:chartFieldCode-${this.motletId}`, this.chartField.code);
              });
          }
        }
        // BEGIN::Added.by.SHJ.2026.04.13.
        if (this.memoryTypeOptions.use) {
          if (this.memoryTypeData.selected !== this.memoryTypeData.previous) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/memoryType`,
                motletProperties: this.memoryTypeData.selected,
              })
              .then(() => {
                bus.$emit(`update:memoryType-${this.motletId}`, this.memoryTypeData.selected);
              });
          }
        }
        if (this.chartTypeOptions.use) {
          if (this.chartTypeData.selected !== this.chartTypeData.previous) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/chartType`,
                motletProperties: this.chartTypeData.selected,
              })
              .then(() => {
                bus.$emit(`update:chartType-${this.motletId}`, this.chartTypeData.selected);
              });
          }
        }
        // FINISH::Added.by.SHJ.2026.04.13.
        // BEGIN::Added.by.SHJ.2026.04.22.
        if (this.bufferTypeOptions.use) {
          if (this.bufferTypeData.selected !== this.bufferTypeData.previous) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/bufferType`,
                motletProperties: this.bufferTypeData.selected,
              })
              .then(() => {
                bus.$emit(`update:bufferType-${this.motletId}`, this.bufferTypeData.selected);
              });
          }
        }
        // FINISH::Added.by.SHJ.2026.04.22.
        // BEGIN::Added.by.SHJ.2026.04.28.
        if (this.fsysTypeOptions.use) {
          if (this.fsysTypeData.selected !== this.fsysTypeData.previous) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/fsysType`,
                motletProperties: this.fsysTypeData.selected,
              })
              .then(() => {
                bus.$emit(`update:fsysType-${this.motletId}`, this.fsysTypeData.selected);
              });
          }
        }
        // FINISH::Added.by.SHJ.2026.04.28.
        if (this.xAxisPointsOptions.use) {
          if (this.xAxisPointsData.selected !== this.xAxisPointsData.previous) {
            this.setXAxisPoints(this.xAxisPointsData.selected);
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.motletId}/xAxisPoints`,
                motletProperties: this.xAxisPoints,
              })
              .then(() => {
                bus.$emit(`update:xAxisPoints-${this.motletId}`, this.xAxisPoints);
              });
          }
        }
      }
    },
    // FINISH::Added.by.KWShin.2024.03.06.
  },
  methods: {
    // BEGIN::Added.by.KWShin.2024.03.06.
    onXAxisMinus() {
      if (this.xAxisPointsData.selected <= 30) {
        this.$snackbar(this.$t('dv.info.xaxis.lt.30'));
        return;
      }
      this.xAxisPointsData.selected -= 10;
      // this.monitor는 mixins[motletable]에서 motletOptions.monitor의 값이 할당된 것이다.
      // motletOptions 에는 이 모틀릿을 호출하는 컴포넌트 측에서 필요한 값들이 설정되어 온다.
      this.xAxisPointsData.timeText = s2Hms(this.xAxisPointsData.selected * (this.monitor.cycle / 1000));
    },
    onXAxisPlus() {
      if (this.xAxisPointsData.selected >= 360) {
        this.$snackbar(this.$t('dv.info.xaxis.gt.360'));
        return;
      }
      this.xAxisPointsData.selected += 10;
      this.xAxisPointsData.timeText = s2Hms(this.xAxisPointsData.selected * (this.monitor.cycle / 1000));
    },
    // FINISH::Added.by.KWShin.2024.03.06.
  },
};
</script>

<style>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0px;
}
/*
 * 'minus-btn'이라는 id를 가진 button 태그를 가진,
 * 'v-input__prepend-outer'라는 클래스를 가진 div 태그에 
 * CSS를 적용하라! 
 * 젠장... 이렇게 해서 Vuetify component의 slot이 가진
 * 디폴트 스타일을 변경했다.
 * 2024.01.17.KWShin.
*/
div.v-input__prepend-outer:has(button#minus-btn) {
  margin: 2px 0px 0px 10px;
}
div.v-input__append-outer:has(button#plus-btn) {
  margin: 2px 0px 0px 0px;
}
div#gear-menu-text-field div.v-input input {
  text-align: right;
}
</style>
